import { Col, Row, Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function HeroSection({ ...props }) {
	const { account, language } = useContext(CoreAdoptionContext)
	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<div className="absolute top-0 left-0 z-0 h-full w-full bg-cover bg-no-repeat opacity-75" style={{ backgroundImage: 'url(/images/arc-core/books-bg.jpg)' }}>
				<div className="white-transparent-gradient-strong h-full w-full"></div>
			</div>
			<Row center className="relative z-10 pt-10 sm:pt-20">
				<Col width="w-full sm:w-2/3">
					<h1>
						<StaticImage src="../../../static/images/logos/arc-core-logo-halo.png" loading="eager" alt="arc core logo" />
					</h1>
				</Col>
			</Row>
			<Row center className="relative z-10 -mt-4 md:-mt-12">
				<Col width="w-full md:w-5/6 xl:w-2/3">
					<span className="block text-center text-2xl font-bold leading-tight text-ab-100 md:text-3xl lg:text-5xl">{account?.name}</span>
					<span className="block text-center text-2xl font-medium leading-tight md:text-3xl lg:text-4xl">
						{language === 'english'
							? 'One Comprehensive Solution for Transformative Literacy, Grades K–12'
							: 'Una solución para la lectoescritura transformativa, Grados K-12'}
					</span>
					<p className="mt-6 text-left text-lg sm:mt-12 sm:text-center sm:text-xl">
						{language === 'english'
							? 'Founded and run by educators, American Reading Company is committed to its mission of ensuring all students read on or above grade level.'
							: 'Fundada y administrada por educadoras y educadores, American Reading Company está comprometida a asegurar que todos los estudiantes estén leyendo por encima o al nivel de su grado.'}
					</p>
					<p className="mt-6 text-left text-lg sm:mt-12 sm:text-center sm:text-xl">
						{language === 'english'
							? "American Reading Company's high-quality comprehensive core curriculum, ARC Core, is grounded in the science of reading and includes culturally responsive, inquiry-based, thematic units of study, available K–12 in English and K–5 in Spanish, that build literacy skills by integrating reading, writing, science, and social studies content in a student-centered learning environment."
							: 'El currículo riguroso y comprensivo de American Reading Company, ARC Core, incluye unidades de estudio temáticas culturalmente inclusivas y basadas en la investigación, disponibles para los grados K-12 para inglés y K-5 para español, que integran la lectura, escritura y contenido de ciencias y estudios sociales en un ambiente de aprendizaje centrado en el estudiante.'}
					</p>
				</Col>
			</Row>
		</Section>
	)
}
